import { content } from '@ux/type-size';
import { gu2px } from '@ux/theme-utils';

export default ({
  theme,
}) => {
  const {
    typography,
    palette,
    spacing,
  } = theme;

  return {
    default: {
      root: {
        display: 'block',
      },
      title: {
        color: palette.primary,
        ...content(typography),
        marginBottom: gu2px(1, spacing),
        marginTop: 0,
        fontWeight: 600,
        padding: 0,
      },
      text: {
        ...content(typography),
        marginBottom: gu2px(1, spacing),
        marginTop: 0,
        color: palette.grey04,
      },
      link: {
        whiteSpace: 'nowrap',
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/presentation/components/header/Header.stylesheet.js